import { Stack, Typography } from "@mui/material";
import type { TextEntityFieldConfiguration } from "../../../../../api/types/objectTypes";

interface Props {
  fieldConfiguration: TextEntityFieldConfiguration;
}

const TextFieldConfigViewer = ({ fieldConfiguration }: Props) => {
  if (fieldConfiguration.maxLength === undefined) {
    return null;
  }

  return (
    <Stack spacing={1} sx={{ pt: 2 }}>
      <Typography variant="subtitle2">Constraints</Typography>
      <Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between" }}>
        <Typography color="textSecondary">Maximum length</Typography>
        <Typography>{`${fieldConfiguration.maxLength} characters`}</Typography>
      </Stack>
    </Stack>
  );
};

export default TextFieldConfigViewer;
